import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-xl p-5 mb-5" }
const _hoisted_2 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-base text-gray-800" }, "Komisi Per RIT", -1)
const _hoisted_4 = { class: "pi pi-info-circle text-blue-500 cursor-pointer text-base" }
const _hoisted_5 = { class: "bg-blue-50/60 border border-blue-100 rounded-xl p-4 flex flex-col gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "commTypeOneTime",
    class: "font-semibold text-sm cursor-pointer text-gray-800"
  }, "Mandoran Pertama"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Komisi untuk Mandoran pertama yang tap NFC ke Kondektur.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "commTypeTiered",
    class: "font-semibold text-sm cursor-pointer text-gray-800"
  }, "Jumlah Penumpang Dibawa"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Komisi untuk Mandoran sesuai jumlah penumpang yang dibawa.")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback text-xs text-red-500 mt-2"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm text-gray-800 block mb-1" }, "Komisi Mandoran Pertama (Rp)", -1)
const _hoisted_11 = { class: "w-72" }
const _hoisted_12 = { class: "p-inputgroup flex-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_14 = { class: "invalid-feedback text-xs text-red-500 mt-1" }
const _hoisted_15 = {
  key: 2,
  class: "mt-4"
}


import RadioButton from 'primevue/radiobutton'
import InputNumber from 'primevue/inputnumber'
import { ITierRow } from '@/utils/interfaces/iSalesAgentCommission'
import FormTierTable from './FormTierTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormRitCommission',
  props: {
    values: null,
    errors: null,
    tiers: null,
    tiersGeneralError: null
  },
  emits: ["select-type", "change-number", "blur-field", "tier-input", "blur-tiers", "add-tier", "remove-tier"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select-type', type: string): void
  (e: 'change-number', field: any, val: any): void
  (e: 'blur-field', field: any): void
  (e: 'tier-input', tier: ITierRow, field: 'minPassenger' | 'maxPassenger' | 'commissionAmount', val: any): void
  (e: 'blur-tiers'): void
  (e: 'add-tier'): void
  (e: 'remove-tier', idx: number): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("i", _hoisted_4, null, 512), [
        [
          _directive_tooltip,
          'Komisi yang akan diterima Mandoran per 1 RIT.',
          void 0,
          { top: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "flex items-start gap-3 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = () => emit('select-type', 'OneTime'))
      }, [
        _createVNode(_unref(RadioButton), {
          inputId: "commTypeOneTime",
          name: "commissionType",
          value: "OneTime",
          modelValue: __props.values.commissionType
        }, null, 8, ["modelValue"]),
        _hoisted_6
      ]),
      _createElementVNode("div", {
        class: "flex items-start gap-3 cursor-pointer",
        onClick: _cache[1] || (_cache[1] = () => emit('select-type', 'Tiered'))
      }, [
        _createVNode(_unref(RadioButton), {
          inputId: "commTypeTiered",
          name: "commissionType",
          value: "Tiered",
          modelValue: __props.values.commissionType
        }, null, 8, ["modelValue"]),
        _hoisted_7
      ])
    ]),
    (__props.errors.commissionType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.errors.commissionType), 1))
      : _createCommentVNode("", true),
    (__props.values.commissionType === 'OneTime')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_unref(InputNumber), {
                modelValue: __props.values.oneTimeCommissionAmount,
                placeholder: "0",
                min: 0,
                max: 99999,
                locale: "id-ID",
                class: "w-full",
                inputClass: __props.errors.oneTimeCommissionAmount ? 'p-invalid w-full' : 'w-full',
                onInput: _cache[2] || (_cache[2] = (e) => emit('change-number', 'oneTimeCommissionAmount', e)),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => emit('change-number', 'oneTimeCommissionAmount', val)),
                onBlur: _cache[4] || (_cache[4] = () => emit('blur-field', 'oneTimeCommissionAmount'))
              }, null, 8, ["modelValue", "inputClass"])
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(__props.errors.oneTimeCommissionAmount), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.values.commissionType === 'Tiered')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(FormTierTable, {
            tiers: __props.tiers,
            tiersGeneralError: __props.tiersGeneralError,
            onTierInput: _cache[5] || (_cache[5] = (tier, field, val) => emit('tier-input', tier, field, val)),
            onBlurTiers: _cache[6] || (_cache[6] = () => emit('blur-tiers')),
            onAddTier: _cache[7] || (_cache[7] = () => emit('add-tier')),
            onRemoveTier: _cache[8] || (_cache[8] = (idx) => emit('remove-tier', idx))
          }, null, 8, ["tiers", "tiersGeneralError"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})